import api from "@Api/index";
export const getBillingEngines = async () => {
    return api.get("/billing-engines").then(({ data }) => data);
};
